<template>
	<router-view key="projects"></router-view>
</template>

<script>
	export default {}
</script>

<style scoped>
	
</style>


// WEBPACK FOOTER //
// src/components/Projects/Index.vue